import { Blog, MenuType } from "@/types";
import { footerLinks } from "@/content/business-details/business-content";
import { categoryDetails as category1 } from "@/content/services/1";
import { categoryDetails as category2 } from "@/content/services/2";

export const footerData: MenuType[] = [
  {
    label: "Sitemap",
    children: [
      { label: "Services", href: "/services" },
      { label: "Contact", href: "/contact" },
      { label: "About", href: "/about" },
    ],
  },
  {
    label: category1.name,
    href: `/${category1.categoryType}/${category1.slug}`,
    children:
      category1.subCategories?.map((service: Blog) => ({
        href: `/${category1.categoryType}/${category1.slug}/${service.slug}`,
        label: service.title,
      })) || [],
  },
  {
    label: category2.name,
    href: `/${category2.categoryType}/${category2.slug}`,
    children:
      category2.subCategories?.map((service: Blog) => ({
        href: `/${category2.categoryType}/${category2.slug}/${service.slug}`,
        label: service.title,
      })) || [],
  },
  ...(footerLinks.length
    ? [
        {
          label: "Legal",
          children: footerLinks.map((link) => ({
            label: link.label,
            href: link.url,
          })),
        },
      ]
    : []),
];
